import { Injectable } from "@angular/core";
import { MapperInterface } from "../mapper-inteface";
import { DestinatarioInternoDTO } from "@app/shared/dto/gescor/destinatario-internoDTO";
import { DestinatarioInternoVO } from "@app/shared/vo/gescor/destinatario-internoVO";

@Injectable({
  providedIn: "root",
})
export class MapperDestinatarioInterno
  implements MapperInterface<DestinatarioInternoDTO, DestinatarioInternoVO> {
  convertVoToDto(
    destinatarioInternoVO: DestinatarioInternoVO
  ): DestinatarioInternoDTO {
    let destinatarioInternoDTO = new DestinatarioInternoDTO();
    destinatarioInternoDTO.cmu = destinatarioInternoVO.idCmu;
    destinatarioInternoDTO.codice = destinatarioInternoVO.idCmu;
    destinatarioInternoDTO.tipoDestinatario =
      destinatarioInternoVO.tipoDestinatario;
    destinatarioInternoDTO.nome = destinatarioInternoVO.nomeCmu;
    return destinatarioInternoDTO || new DestinatarioInternoDTO();
  }

  convertDtoToVo(
    destinatarioInternoDTO: DestinatarioInternoDTO
  ): DestinatarioInternoVO {
    let destinatarioInternoVO = new DestinatarioInternoVO();
    destinatarioInternoVO.idCmu = destinatarioInternoDTO.cmu;
    destinatarioInternoVO.tipoDestinatario =
      destinatarioInternoDTO.tipoDestinatario;
    destinatarioInternoVO.nomeCmu = destinatarioInternoDTO.nome;
    return destinatarioInternoVO || new DestinatarioInternoVO();
  }

  convertListVoToDto(
    destinatarioInternoVOList: DestinatarioInternoVO[]
  ): DestinatarioInternoDTO[] {
    let destinatarioInternoDTOList = new Array<DestinatarioInternoDTO>();
    destinatarioInternoVOList.forEach((destinatarioInternoVO) => {
      destinatarioInternoDTOList.push(
        this.convertVoToDto(destinatarioInternoVO)
      );
    });
    return destinatarioInternoDTOList || new Array<DestinatarioInternoDTO>();
  }

  convertListDtoToVo(
    destinatarioInternoDTOList: DestinatarioInternoDTO[]
  ): DestinatarioInternoVO[] {
    const destinatarioInternoVOList = new Array<DestinatarioInternoVO>();
    if (destinatarioInternoDTOList != null) {
      destinatarioInternoDTOList.forEach((destinatarioInternoDTO) => {
        destinatarioInternoVOList.push(
          this.convertDtoToVo(destinatarioInternoDTO)
        );
      });
    }
    return destinatarioInternoVOList || new Array<DestinatarioInternoVO>();
  }
}
